import { graphql, useStaticQuery } from "gatsby";
import {
  ShowStore,
  extract,
  RideStore,
  TextBlockStore,
  RestaurantStore,
  PlaceholderImageHelper,
} from "@parksandresorts/core";
import "components/blocks/my-page-block/query";

/** @returns {import("@parksandresorts/core").SimplifyGatsbyQuery<Queries.StaticDataQuery>} */
export const useStaticData = () => {
  const data = useStaticQuery(query);
  return data;
};

const StoreFactory = (props) => {
  const data = useStaticData();

  ShowStore.populateStore(extract(data, "allContentfulShowBlock.edges"));
  RideStore.populateStore(extract(data, "allContentfulRideBlock.edges"));
  RestaurantStore.populateStore(data?.allContentfulRestaurantBlock?.edges || []);
  TextBlockStore.populateStore(extract(data, "allContentfulTextBlock.nodes"));

  PlaceholderImageHelper.setPlaceholderImages({
    eventRow: "/images/my-pages/sommarland-logo.svg",
    cartItem: "/images/my-pages/sommarland-logo.svg",
    sendGift: "/sommarland-send-gift.png",
    myParksGiftWrapper: "/images/my-pages/rod-rosett.png",
  });

  return <>{props.children}</>;
};

const query = graphql`
  query StaticData {
    allGlkProduct {
      nodes {
        ...GLKProduct
      }
    }
    allContentfulProductBlock(filter: { productName: { ne: null } }) {
      edges {
        node {
          ...ProductBlock
        }
      }
    }
    allContentfulShowBlock {
      edges {
        node {
          contentful_id
          node_locale
          internalTitle
          id
          sortIndex
          preHeading
          title
          preamble {
            preamble
          }
          label
          shortDescriptionInList
          pageLink {
            slug
          }
          imageInList {
            file {
              url
            }
            gatsbyImageData(width: 132, height: 132, layout: FIXED, resizingBehavior: FILL)
          }
          tags {
            title
          }
          length
          location
          product {
            contentful_id
            productPageLink {
              slug
            }
          }
          mapLink {
            id
            title
            smallDeviceTitle
            internalLink {
              slug
            }
            externalUrl
            openInNewTab
            image {
              file {
                url
              }
            }
            asset {
              file {
                url
              }
            }
            icon
          }
          showInPurchaseFlow
          showProductDescriptionTextInPurchaseFlow
        }
      }
    }
    allContentfulRideBlock(filter: { title: { ne: null } }) {
      edges {
        node {
          ...RideBlockStore
        }
      }
    }
    allContentfulRestaurantBlock(filter: { title: { ne: null } }) {
      edges {
        node {
          node_locale
          ...RestaurantBlock
        }
      }
    }
    allContentfulTextBlock(filter: { richText: { raw: { ne: null } } }) {
      nodes {
        id
        contentful_id
        node_locale
        internalTitle
        componentTheme
        richText {
          raw
          references {
            __typename
            ...Link
            ...Asset
          }
        }
        image {
          gatsbyImageDataXs: gatsbyImageData(width: 512)
          gatsbyImageDataS: gatsbyImageData(width: 640)
          gatsbyImageDataM: gatsbyImageData(width: 960)
          gatsbyImageDataL: gatsbyImageData(width: 1440)
          gatsbyImageDataCornerMobile: gatsbyImageData(width: 100, height: 100)
          gatsbyImageDataCornerDesktop: gatsbyImageData(width: 200, height: 200, outputPixelDensities: [1])
          description
        }
        animation {
          url
        }
        useCustomColors
        customColors {
          backgroundColor
          textColor
          headingColor
          neonColorBase
          neonColorShine
          linkColor
          buttonTextColor
          buttonBackgroundColor
        }
      }
    }
    # this filters out the mocked entity (similar to our GraphQL-entries in Contentful)
    allGlkOpeningHours(filter: { opens: { lt: "2099" } }) {
      nodes {
        id
        internal {
          type
          content
        }
      }
    }
  }
`;

export default StoreFactory;
